/* global __DUCKDB_WASM_VERSION__ */
// The DuckDB WASM version the browser loads from the CDN (jsDelivr wasm + worker here,
// esm.sh via the app's importmap). Injected at build time by @rdrive/vite-config's
// createDashboardVite() through Vite `define`, from the version pnpm installed for the
// catalog pin in pnpm-workspace.yaml — ONE source for all three (PACKAGING_PLAN.md §2.3).
//
// Outside the preset (plain Node, a test runner) the global does not exist and this is
// `null`; DuckDBService.initialize() then throws instead of guessing a version.

/** @type {string | null} */
export const DUCKDB_WASM_VERSION =
  typeof __DUCKDB_WASM_VERSION__ === 'string' ? __DUCKDB_WASM_VERSION__ : null;
